import { createAction } from 'redux-actions'

import * as TYPES from '../type'

export const SetToken = createAction(
  TYPES.SET_USER_TOKEN,
  action => action
)


// WEBPACK FOOTER //
// ./src/actions/index.js